import { Component, HostListener, Input, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ITrip } from 'src/app/core/types/interfaces/popular-trip.interface';

import { TripCardComponent } from 'src/app/shared/components/trip-card/trip-card.component';

@Component({
    selector: 'app-trip-card-list',
    templateUrl: './trip-card-list.component.html',
    styleUrls: ['./trip-card-list.component.scss'],
    imports: [TripCardComponent, TranslateModule]
})
export class TripCardListComponent implements OnInit {
  @Input() trips: ITrip[] = [];
  @Input() isFetching: boolean = false;

  currentVisibleItems = 10;

  public get showMorePlacesCount(): number {
    return Math.max(this.trips.length - this.currentVisibleItems, 0);
  }

  public get activeTrips(): any[] {
    return this.isFetching
      ? new Array(this.currentVisibleItems)
      : this.trips.slice(0, this.currentVisibleItems);
  }

  ngOnInit() {
    this.updateItemsCount();
  }

  public showMore(): void {
    const screenWidth = window.innerWidth;
    this.currentVisibleItems += screenWidth > 1862 ? 10 : 8;
  }

  @HostListener('window:resize', ['$event'])
  private onResize(): void {
    this.updateItemsCount();
  }

  private updateItemsCount(): void {
    const screenWidth = window.innerWidth;
    this.currentVisibleItems = screenWidth > 1862 ? 10 : 8;
  }
}
